import gql from 'graphql-tag'
export default gql`
mutation verifyUsername($username: String! ){
    verifyUsername(username: $username )
  }`
//   {
//       "username": "9028887875"
// }